import { HCPUserSubHeaderProps, ManufacturerSubHeaderProps, UserType } from "../../types/users";

export type UserContextProps = {
  isUserAuthorized: boolean;
  isManufacturer: boolean;
  authToken: string;
  defaultView: string;
  userData: UserType | null;
  sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps | null;
  isRestoreCalled: boolean;
  createSession: (userData: UserType, sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps, authToken: string, defaultView: string,reinvestigation:boolean,eob_warehouse: boolean,upload_eob: boolean,cep_popup: boolean, new_baa_user_1_2: boolean, outreach: boolean, pcc_outreach: boolean) => void;
  destroySession: () => void;
  restoreSession: () => boolean;
  updateUserToken: (userToken: string) => void;
  updateUserData : (userData: UserType, defaultView: string, reinvestigation:boolean, outreach: boolean, pcc_outreach: boolean) => void;
  reinvestigation:boolean;
  eob_warehouse: boolean,
  upload_eob: boolean,
  cep_popup: boolean;
  new_baa_user_1_2: boolean;
  outreach: boolean;
  pcc_outreach: boolean;
};

export type manufactureruserType = {
  userId : number;
  userName : string;
}

export type AuthProviderProps = {
  children: JSX.Element;
};

export type AuthStateProps = {
  isUserAuthorized: boolean;
  isManufacturer: boolean;
  authToken: string;
  defaultView: string;
  reinvestigation:boolean;
  userData: UserType | null;
  sub_header: HCPUserSubHeaderProps | ManufacturerSubHeaderProps | null;
  isRestoreCalled: boolean;
  eob_warehouse: boolean,
  upload_eob: boolean,
  cep_popup: boolean
  new_baa_user_1_2: boolean;
  outreach: boolean;
  pcc_outreach: boolean;
};

export enum AuthStateActions {
  SET_SESSION = 'setSession',
  UPDATE_USER_DATA = 'updateUserData',
  UPDATE_USER_TOKEN = 'updateUserToken',
  CLEAR_SESSION = 'clearSession',
  UPDATE_USER_MANUFACTURE_DATA = 'updateManufactureUser',
  GET_USER_MANUFACTURE_DATA = 'getManufactureUser',
};

export type AuthStateAction = {
  type: AuthStateActions.SET_SESSION;
  payload: AuthStateProps;
} | {
  type: AuthStateActions.UPDATE_USER_DATA;
  payload: { userData: UserType, defaultView: string, reinvestigation:boolean; isManufacturer:boolean,
    new_baa_user_1_2: boolean; outreach: boolean; pcc_outreach: boolean;
 };
} | {
  type: AuthStateActions.UPDATE_USER_TOKEN;
  payload: string;
} | {
  type: AuthStateActions.CLEAR_SESSION;
} 
|{
  type: AuthStateActions.GET_USER_MANUFACTURE_DATA;
};
